// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__T78Ae","CurseContent":"styles_CurseContent__X54F8"};